export class AccountResetModel {
    public key: string;
    public secret: string;
    public newPassword: string;
    public confirmPassword: string;
}
